import cartImg from "../../assets/img/productPage1.png";

const cartList = [
    {
        id: 1,
        img: cartImg,
        wishList: false,
        quantity: 2,
        selectedStore: "sa",
        stores: ["sa", "qa", "om", "kw", "ae", "en"],
        selectedBalance: 40,
        balance: [20, 40, 60, 80, 100, 120, 140, 160, 180, 185, 190, 195, 200],
        price: 90,
        ar: {
            name: "بطاقة شحن شدات ببجى"
        },
        en: {
            name: "PUBG UC Cards"
        }
    },
    {
        id: 2,
        img: cartImg,
        wishList: true,
        quantity: 2,
        selectedStore: "sa",
        stores: ["sa", "qa", "om", "kw", "ae", "en"],
        selectedBalance: 40,
        balance: [20, 40, 60, 80, 100, 120, 140, 160, 180, 185, 190, 195, 200],
        price: 90,
        ar: {
            name: "بطاقة شحن شدات ببجى"
        },
        en: {
            name: "PUBG UC Cards"
        }
    }
];

const summary = {
    total: 290,
    ar: {
        currancy: "ر.س."
    },
    en: {
        currancy: "SAR"
    },
    orders: [
        {
            id: 1,
            price: 90,
            ar: {
                title: "شدادات ببجى"
            },
            en: {
                title: "PUBG UC"
            }
        },
        {
            id: 2,
            price: 200,
            ar: {
                title: "حساب بلايستيشن 6 شهور"
            },
            en: {
                title: "Playsation account 6 months"
            }
        }
    ]
};

export { cartList, summary };
